<template>
  <Modal
    title="修改密码"
    :value="value"
    @on-visible-change="onVisibleChange"
    :mask-closable="false"
    @on-cancel="onVisibleChange(false)"
  >
    <Form
      ref="editForm"
      :model="editData"
      :rules="editRules"
      inline
      :label-width="125"
    >
      <Row>
        <Col span="24">

        <FormItem
          label="新密码"
          prop="pwd"
        >
          <Input
            type="password"
            v-model="editData.pwd"
            placeholder="请输入密码"
          >
          </Input>
        </FormItem>
        </Col>
        <Col span="24">

        <FormItem
          label="确认密码"
          prop="pwd2"
        >
          <Input
            type="password"
            v-model="editData.pwd2"
            placeholder="请输入密码"
          >
          </Input>
        </FormItem>
        </Col>
      </Row>
      <Row>
        <Col
          span='8'
          offset='10'
          class="btn-groups"
        >
        <Button
          type="primary"
          @click="clickSave"
        >保存</Button>
        <Button
          type="default"
          @click="clickCancel"
        >取消</Button>
        </Col>
      </Row>
    </Form>
    <div slot="footer"></div>
  </Modal>
</template>

<script>
import CTable from '@/components/CTable'
import BtnEvent from '@/components/BtnEvent'
import {areaRule} from '@/plugin/validateRule'
import {timeFormat} from '@/plugin/tool'
export default {
  name: 'EditModal',
  mixins: [BtnEvent],
  components: {
    CTable
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: Boolean
  },
  watch: {
  },
  data () {
    return {
      defaultFileList: [],
      editData: {
        pwd: '',
        pwd2: ''
      },
      editRules: {
        pwd: [
          {required: true,message: '请输入密码',trigger: 'blur'}
        ],
        pwd2: [
          {required: true,message: '请输入密码',trigger: 'blur'}
        ],
      }
    }
  },
  created () {
  },
  methods: {
    setData (data) {
      this.editData=data
    },
    deleteAction (p) {
      this.$emit('on-delete',p)
    },
    onVisibleChange (value) {
      if(this.value!==value) {
        this.$emit('change',value)
      }
      if(value) {
        this.$refs['editForm'].resetFields();
      }
    },
    clickCancel () {
      this.$emit('change',false)
    },
    onUploadSuccess (res,file,fileList) {
      this.editData.fujianAddr=res.data.picName
    },
    clickSave () {
      this.$refs['editForm'].validate((valid) => {
        if(valid&&this.editData.pwd===this.editData.pwd2) {
          this.$emit('on-save',this.editData)
        } else {
          this.$Message.error('Fail!');
        }
      })
    }
  }
}
</script>
<style >
.ivu-upload {
  width: 100%;
}
</style>
